"use client";

// packages/eden-headings/src/components/H4.jsx
import styled from "styled-components";
import { jsx } from "react/jsx-runtime";
var H4Styled = styled.h4`
  margin: 0;
  font: normal normal 600 calc(18rem / 16) / 1.2 var(--unity-font-family-sans);
`;
var H4 = ({ children, renderAs, ...props }) => /* @__PURE__ */ jsx(H4Styled, { as: renderAs, ...props, children });
H4.displayName = "H4";
var H4_default = H4;
export {
  H4_default as default
};
